module.exports = __webpack_public_path__ + "img/ly.09642f9.png";